import React, {useCallback, useState} from 'react';
import Heading from 'js/components/Common/Heading/Heading';
import MixPanelWrapper from 'js/servises/MixPanelWrapper';
import useFetchData from 'js/hooks/useFetchData/useFetchData';
import Container from 'js/components/Common/Container/Container';
import EmbedVideo from 'js/components/Common/EmbedVideo/EmbedVideo';
import DataValidator from 'js/components/Common/DataValidator/DataValidator';
import {ImageBlockDataInterface} from 'js/components/Common/Image/ImageBlockDataInterface';

import fetchData from './fetchData';
import classes from './VideoHome.module.pcss';


interface Props {
    pageId: number
}

type VideoType = {
    videoLink: string,
    videoPreview: ImageBlockDataInterface
}

const VideoHome = ({pageId}: Props) => {
    const [title, setTitle] = useState<string>('');
    const [video, setVideo] = useState<VideoType>(null);

    const {isLoading, error} = useFetchData({
        query: `${fetchData(pageId)}`,
        condition: !!pageId,
        updateData: (data: any): void => {
            const result = data?.page?.PostLoginPage;
            setTitle(result?.homeVideoTitle);
            setVideo(result?.attachedVideo);
        }
    });

    const sendMixPlayEvent = useCallback(async (heading:string) => (
        await MixPanelWrapper.TrackEvent(
            'Play Video',
            {
                category: 'Home page',
                value: heading
            })
    ), []);


    return (
        <DataValidator data={!isLoading && !error && title?.length > 0 && video?.videoLink?.length > 0}>
            <section className={classes.VideoHome}>
                <Container additionalClass={classes.Wrap}>
                    <Heading text={title} />
                    <EmbedVideo
                        title={title}
                        customVideoSize={{
                            width: '960',
                            height: '536'
                        }}
                        sendEventHandler={async (value: string) => await sendMixPlayEvent(value)}
                        link={video?.videoLink}
                        preview={video?.videoPreview} />
                </Container>
            </section>
        </DataValidator>
    );
};

export default VideoHome;
